import { render, staticRenderFns } from "./desc-node.vue?vue&type=template&id=1c2c6aee&scoped=true&"
import script from "./desc-node.vue?vue&type=script&lang=js&"
export * from "./desc-node.vue?vue&type=script&lang=js&"
import style0 from "./desc-node.vue?vue&type=style&index=0&id=1c2c6aee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2c6aee",
  null
  
)

export default component.exports